var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-header',{attrs:{"title":"控制台计费"}}),_c('div',{staticClass:"center"},[_vm._v("\n    该系统正在开发中\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }